import { render, staticRenderFns } from "./ApartmentListPage.vue?vue&type=template&id=5ef9cfdc&"
import script from "./ApartmentListPage.vue?vue&type=script&lang=js&"
export * from "./ApartmentListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports